module.exports = __webpack_public_path__ + "rs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/rs.svg
// module id = 1037
// module chunks = 0